import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=a0a68a28&scoped=true"
import script from "./Ventas.vue?vue&type=script&lang=js"
export * from "./Ventas.vue?vue&type=script&lang=js"
import style0 from "./Ventas.vue?vue&type=style&index=0&id=a0a68a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a68a28",
  null
  
)

export default component.exports